import AMapLoader from '@amap/amap-jsapi-loader'
import { App, reactive } from 'vue'
import { AMapConfig } from '/@/constants/index'

import Map from 'ol/Map'
// import OLCesium from 'olcs'

import View from 'ol/View'
import { fromLonLat, toLonLat } from 'ol/proj'
import GeoTIFF from 'ol/source/GeoTIFF.js'
import TileLayer from 'ol/layer/WebGLTile'
import VectorTileLayer from 'ol/layer/VectorTile'
import VectorTileSource from 'ol/source/VectorTile'
import ImageTile from 'ol/source/ImageTile'
import XYZ from 'ol/source/XYZ'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import MVT from 'ol/format/MVT'
import Point from 'ol/geom/Point'
import { Icon, Circle, Fill, Stroke, Style, Text } from 'ol/style'
import { Draw } from 'ol/interaction'
import GeoJSON from 'ol/format/GeoJSON'
import { vectorTileStyle } from '/@/hooks/use-g-map-style'
import Raster from 'ol/source/Raster'
import ImageLayer from 'ol/layer/Image'

export function useGMapManage () {
  const state = reactive({
    aMap: null, // Map类
    map: null, // 地图对象
    mouseTool: null,
    flightRouteArrowLayer: null,
    flightRouteBoundaryLayer: Draw,
    contourLineLayer: null
  })

  async function initMap (container: string, app:App) {
    // const mapStyle = await import('/@/assets/map/style.json')
    // AMapLoader.load({
    //   ...AMapConfig
    // }).then((AMap) => {
    //   state.aMap = AMap
    //   state.map = new AMap.Map(container, {
    //     center: [113.943225499, 22.577673716],
    //     zoom: 20
    //   })
    //   state.mouseTool = new AMap.MouseTool(state.map)

    //   // 挂在到全局
    //   app.config.globalProperties.$aMap = state.aMap
    //   app.config.globalProperties.$map = state.map
    //   app.config.globalProperties.$mouseTool = state.mouseTool
    // }).catch(e => {
    //   console.log(e)
    // })
    const waterLayer = new VectorTileLayer({
      source: new VectorTileSource({
        format: new MVT(),
        url: AMapConfig.url + '/tiles/simplified-water/{z}/{x}/{y}.pbf',
        minZoom: 0,
        maxZoom: 5,
      }),
      style: vectorTileStyle
    })

    const southKoreaLayer = new VectorTileLayer({
      source: new VectorTileSource({
        format: new MVT(),
        url: AMapConfig.url + '/tiles/south-korea-osm/{z}/{x}/{y}.pbf',
        minZoom: 0,
        maxZoom: 9,
      }),
      style: vectorTileStyle
    })

    const landLayer = new VectorTileLayer({
      source: new VectorTileSource({
        format: new MVT(),
        url: AMapConfig.url + '/tiles/simplified-land/{z}/{x}/{y}.pbf',
        minZoom: 0,
        maxZoom: 5,
      }),
      style: vectorTileStyle
    })

    const asiaCementBaseLayer =
      new TileLayer({
        id: 'asiaCementBaseLayer',
        source: new GeoTIFF({
          sources: [
            {
              url: AMapConfig.url + '/tiles-raster/asia-cement/orthomosaic_cog_3857.tif',
            }
          ],
          transition: 0,
          // projection: 'EPSG:3857'
        }),
        cacheSize: 256,
        maxZoom: 19,
      })

    // tiles better for greateer zoom > 19
    const asiaCementBaseXyzLayer =
      new TileLayer({
        id: 'asiaCementBaseXyzLayer',
        source: new XYZ({
          url: AMapConfig.url + '/tiles-raster/asia-cement/tiles/{z}/{x}/{-y}.png',
          tileSize: 256,
          transition: 0,
        }),
        preload: 9, // Prefetch neighbor tiles for smooth panning
        maxZoom: 24,
        minZoom: 18,
      })

    const white = [255, 255, 255, 1]
    const blue = [0, 128, 255, 1]
    const width = 3
    const flightRouteBoundaryLayer = new VectorLayer({
      source: new VectorSource({ wrapX: false }),
      style: new Style({
        stroke: new Stroke({
          color: 'blue',
          width: width + 2,
        }),
        fill: new Fill({
          color: 'rgba(0, 0, 255, 0.4)',
        }),
        image: new Circle({
          radius: width * 2,
          fill: new Fill({
            color: blue,
          }),
          stroke: new Stroke({
            color: white,
            width: width / 2,
          }),
        }),
        zIndex: Infinity,
      }),
    })

    const flightRouteArrowLayer = new VectorLayer({
      source: new VectorSource()
    })

    // const styles = {
    //   route: new Style({
    //     stroke: new Stroke({
    //       width: 6,
    //       color: [237, 212, 0, 0.8],
    //     }),
    //   }),
    // icon: new Style({
    //   image: new Icon({
    //     anchor: [0.5, 1],
    //     src: 'data/icon.png',
    //   }),
    // }),
    // geoMarker: new Style({
    //   image: new CircleStyle({
    //     radius: 7,
    //     fill: new Fill({ color: 'black' }),
    //     stroke: new Stroke({
    //       color: 'white',
    //       width: 2,
    //     }),
    //   }),
    // }),
    // }

    // const route = new Polyline({
    //   factor: 1e6,
    // }).readGeometry(polyline, {
    //   dataProjection: 'EPSG:4326',
    //   featureProjection: 'EPSG:3857',
    // })

    // const routeFeature = new Feature({
    //   type: 'route',
    //   geometry: route,
    // })
    // const startMarker = new Feature({
    //   type: 'icon',
    //   geometry: new Point(route.getFirstCoordinate()),
    // })
    // const endMarker = new Feature({
    //   type: 'icon',
    //   geometry: new Point(route.getLastCoordinate()),
    // })
    // const position = startMarker.getGeometry().clone()
    // const geoMarker = new Feature({
    //   type: 'geoMarker',
    //   geometry: position,
    // })

    // const vectorLayer = new VectorLayer({
    //   source: new VectorSource({
    //     features: [routeFeature, geoMarker, startMarker, endMarker],
    //   }),
    //   style: function (feature) {
    //     return styles[feature.get('type')]
    //   },
    // })

    // const pinFeat = new Feature({
    //   geometry: new Point(fromLonLat([128.31055618348088, 37.2565747455925])),
    //   style: new Style({
    //     image: new Icon({
    //       anchor: [0.5, 0.5],
    //       src: '/@/assets/icons/dock.png',
    //       scale: 0.2,
    //     })
    //   })
    // })

    // const markerLayer = new VectorLayer({
    //   source: new VectorSource({
    //     features: [pinFeat]
    //   }),
    //   style: function (feature) {
    //     return feature.get('style')
    //   }
    // })

    const asiaCementContourLayer =
      new TileLayer({
        id: 'asiaCementContourLayer',
        visible: false,
        source:
        // raster,
        // new Raster({
          new XYZ({
            url: AMapConfig.url + '/tiles-raster/asia-cement/contours/{z}/{x}/{y}.png',
            tileSize: 256,
            transition: 0,
          }),
        // style: {
        //   variables: {
        //     exaggeration: 1.5,
        //     lightAltitude: 45,
        //     lightAzimuth: 315,
        //   },
        //   style: function (feature, resolution) {
        // const elev = getElevation(feature)
        // return getContourStyle(elev, elevMin, elevMax, resolution)
        // },
        // }),
        // operationType: 'image',
        // operation: shade,
        preload: 9, // Prefetch neighbor tiles for smooth panning
        maxZoom: 21,
        minZoom: 13,
        opacity: 0.3, // blend with basemap
        // projection: 'EPSG:3857'
        cacheSize: 256,
      })

    // === Load GeoJSON file (must be same-origin or CORS-enabled) ===
    const contourSource = new VectorSource({
      url: AMapConfig.url + '/tiles-raster/asia-cement/contours_3857.geojson',
      format: new GeoJSON(),
    })

    const demSource = new GeoTIFF({
      sources: [{ url: AMapConfig.url + '/tiles-raster/asia-cement/contours_cog_3857.tif' }], // or remote URL
      normalize: false, // keep raw elevation values (meters)
    })

    const demLayer = new TileLayer({
      id: 'demLayer',
      source: demSource,
      opacity: 0.6,
      // style: { color: ['band', 1] }     // optional grayscale visualization
    })

    // const contourPolygonSource = new VectorSource({
    //   url: AMapConfig.url + '/tiles-raster/asia-cement/contours_simplified_polygon_3857.geojson',
    //   format: new GeoJSON(),
    // })

    // === Style contours ===
    const contourStyle = new Style({
      stroke: new Stroke({
        color: '#FF5733',
        width: 1.5
      }),
      text: new Text({
        font: '10px sans-serif',
        fill: new Stroke({ color: '#000' }),
        textBaseline: 'middle',
        textAlign: 'left',
      })
    })

    // === Define color scale function (blue → green → brown → white) ===
    function getColorForElevation (elev:number, min:number, max:number) {
      const ratio = (elev - min) / (max - min)
      const r = Math.min(255, Math.max(0, 255 * ratio)) // Red increases with elevation
      const g = Math.min(255, Math.max(0, 255 * (1 - ratio))) // Green decreases with elevation
      const b = Math.min(255, Math.max(0, 180 * (1 - ratio))) // Blue fades
      // const r = Math.min(255, Math.max(0, 255 * (1 - ratio))) // Red decreases with elevation
      // const g = Math.min(255, Math.max(0, 255 * ratio)) // Green increase
      // const b = Math.min(255, Math.max(0, 180 * (1 - ratio))) // Blue fades
      return `rgb(${r},${g},${b})`
    }

    const getElevation = (feature: any) => {
      const elev =
        feature?.get('elev') ??
        feature?.get('ELEVATION')

      if (elev !== undefined && !isNaN(elev)) {
        return Number(elev)
      }

      const coords = feature.getGeometry().getCoordinates()
      return coords !== undefined ? coords[0][2] : undefined
    }

    // === Find elevation range dynamically ===
    let elevMin = Infinity; let elevMax = -Infinity
    contourSource.on('addfeature', e => {
      const elev = getElevation(e.feature)
      if (elev !== undefined && !isNaN(elev)) {
        elevMin = Math.min(elevMin, elev)
        elevMax = Math.max(elevMax, elev)
      }
    })

    // === Style function ===
    // const contourStyleFn = (feature:any) => {
    //   const elev = getElevation(feature)
    //   const color = elev !== undefined
    //     ? getColorForElevation(elev, elevMin, elevMax)
    //     : '#888'
    //   return new Style({
    //     stroke: new Stroke({ color, width: 1.5 }),
    //     fill: new Fill({ color }),
    //     text: new Text({
    //       text: elev ? String(Math.round(elev)) : '',
    //       font: '10px sans-serif',
    //       // fill: new Stroke({ color: '#111' }),
    //       offsetY: -8,
    //     })
    //   })
    // }

    function getContourStyle (elev: number | undefined, elevMin: number, elevMax: number, resolution: number) {
      // Map zoom → font size (example formula)
      const baseSize = 10 // font size at zoom 0-ish
      const fontSize = Math.max(6, baseSize * Math.pow(2, -Math.log2(resolution))) // responsive

      const color = elev !== undefined
        ? getColorForElevation(elev, elevMin, elevMax)
        : '#888'

      // Label only every Nth contour
      // const showText = elev !== undefined && resolution < 1.3 && elev % 50 === 0
      const showText = resolution < 1.3

      return new Style({
        stroke: new Stroke({ color, width: 1.5 }),
        fill: new Fill({ color }),
        text: showText
          ? new Text({
            text: elev !== undefined ? String(Math.round(elev)) : '',
            font: `${fontSize}px sans-serif`,
            overflow: false,
            fill: new Fill({ color: '#111' }),
            stroke: new Stroke({ color: '#fff', width: 2 }),
            offsetY: -8,
          })
          : undefined
      })
    }

    const contourLineLayer = new VectorLayer({
      id: 'asiaCementContourLineLayer',
      source: contourSource,
      visible: false,
      declutter: true,
      // style: contourStyleFn
      style: function (feature, resolution) {
        const elev = getElevation(feature)
        return getContourStyle(elev, elevMin, elevMax, resolution)
      },
      opacity: 0.6,
    })

    // const contourPolygonLayer = new VectorLayer({
    //   source: contourPolygonSource,
    //   style: contourStyleFn
    // })

    // const contourLayer = new VectorLayer({
    //   source: contourSource,
    //   style: feature => {
    //     // Label by elevation if available
    //     const elev = feature.get('elev')
    //     const style = contourStyle.clone()
    //     if (elev) style.getText().setText(String(elev))
    //     return style
    //   }
    // })

    const map = new Map({
      target: container,
      layers: [
        waterLayer,
        landLayer,
        southKoreaLayer,
        demLayer,
        asiaCementBaseXyzLayer,
        asiaCementBaseLayer,
        asiaCementContourLayer,
        contourLineLayer,
        // contourPolygonLayer,
        flightRouteBoundaryLayer,
        flightRouteArrowLayer,
        // markerLayer
      ],
      view: new View({
        center: fromLonLat([128.30578, 37.26204]),
        zoom: 15,
        projection: 'EPSG:3857',
        maxZoom: 24 // limit how far users can zoom in
      })
    })

    // Create floating tooltip element
    const tooltip = document.createElement('div')
    tooltip.style.position = 'absolute'
    tooltip.style.background = 'rgba(0,0,0,0.75)'
    tooltip.style.color = 'white'
    tooltip.style.padding = '6px 10px'
    tooltip.style.borderRadius = '4px'
    tooltip.style.pointerEvents = 'none'
    tooltip.style.fontFamily = 'monospace'
    tooltip.style.fontSize = '13px'
    tooltip.style.whiteSpace = 'nowrap'
    tooltip.style.zIndex = '0'
    tooltip.style.display = 'none'
    document.body.appendChild(tooltip)

    // Update on pointer move pointermove (smooth) or 'click'/'singleclick' (less noisy)
    map.on('pointermove', evt => {
      if (evt.dragging) {
        tooltip.style.display = 'none'
        return
      }

      if (tooltip.style.zIndex === '0') {
        return
      }

      tooltip.style.display = 'block'

      // Position tooltip near cursor
      tooltip.style.left = `${evt.pixel[0] + 300}px`
      tooltip.style.top = `${evt.pixel[1] + 30}px`

      const data = demLayer.getData(evt.pixel)

      if (data && data.length > 0) {
        // For single-band elevation GeoTIFF → data[0] is the raw value (Float32)
        const elevation = data[0]

        const lonLat = toLonLat(evt.coordinate)

        tooltip.innerHTML = `
          Lon: ${lonLat[0].toFixed(9)}<br>
          Lat: ${lonLat[1].toFixed(9)}<br>
          Elev: ${elevation.toFixed(2)} m
        `
      } else {
        tooltip.innerHTML = 'No data'
      }
    })

    // Hide when mouse leaves map
    map.getViewport().addEventListener('mouseleave', () => {
      tooltip.style.display = 'none'
    })

    // Add draw interaction
    // const draw = new Draw({
    //   source: flightRouteBoundaryLayer.getSource() ?? undefined,
    //   type: 'Polygon',
    // })
    // mouseTool.setActive(false)

    // const ol3d = new OLCesium({ map: map })
    // ol3d.setEnabled(true)
    // map.addInteraction(mouseTool)
    // app.config.globalProperties.$aMap = OlMap
    // state.flightRouteBoundaryLayer = flightRouteBoundaryLayer
    app.config.globalProperties.$map = map
    // app.config.globalProperties.$mouseTool = draw
    app.config.globalProperties.$flightRouteArrowLayer = flightRouteArrowLayer
    app.config.globalProperties.$flightRouteBoundaryLayer = flightRouteBoundaryLayer
    app.config.globalProperties.$demLayer = demLayer
    app.config.globalProperties.$contourLineLayer = contourLineLayer
    app.config.globalProperties.$cursorTooltip = tooltip
  }

  function globalPropertiesConfig (app:App) {
    initMap('g-container', app)
  }

  return {
    globalPropertiesConfig,
  }
}
